import { t } from "i18next";
import { LoadingPlaceholderItem } from "./shared/LoadingPlaceholderItem";
import { MANAGER_TEAM_WIDGET_MAX_DISPLAY_ITEMS } from "./manager-team/managerTeamWidgetConstants";

interface LoadingDashboardRightBarPlaceholderProps {
  /** Set from the last dashboard API response (managerTeamTodos present); avoids flashing for non-managers. */
  showManagerTeamSection: boolean;
}

function LoadingDashboardRightBarPlaceholder({
  showManagerTeamSection,
}: LoadingDashboardRightBarPlaceholderProps) {
  return (
    <div>
      {showManagerTeamSection && (
        <div
          id="loading-manager-team-list"
          className="bg-white rounded-lg p-4 mb-4"
        >
          <header className="text-lg font-semibold mt-0 mb-2">
            {t("DashboardRightBar.YourTeam")}
          </header>
          {Array.from({ length: MANAGER_TEAM_WIDGET_MAX_DISPLAY_ITEMS }).map(
            (_, index) => (
              <LoadingPlaceholderItem key={`manager-team-loading-${index}`} />
            )
          )}
        </div>
      )}
      <div id="loading-to-do-list" className="bg-white rounded-lg p-4">
        <header className="text-lg font-semibold mt-0 mb-2">
          {t("DashboardRightBar.YourToDoList")}
        </header>
        <LoadingPlaceholderItem />
        <LoadingPlaceholderItem />
        <LoadingPlaceholderItem />
      </div>
      <div id="loading-catch-up-list" className="bg-white rounded-lg p-4 mt-4">
        <header className="text-lg font-semibold mt-0 mb-2">
          {t("DashboardRightBar.YourCatchUps")}
        </header>
        <LoadingPlaceholderItem />
        <LoadingPlaceholderItem />
        <LoadingPlaceholderItem />
      </div>
    </div>
  );
}

export default LoadingDashboardRightBarPlaceholder;
